import { TrustedBackendHtml } from "@/ui-adapters/TrustedBackendHtml";

export interface RichTextViewProps {
  title?: string;
  children: string;
  preview?: boolean;
}

export const RichTextView = ({ children, preview = false, ...props }: RichTextViewProps): React.ReactNode => {
  return <TrustedBackendHtml html={children} preview={preview} {...props} />;
};
